import React, { useState } from 'react';
import { DotLoading } from 'antd-mobile';
import useParams from '@/hooks/useParams';
import { useMount, useTitle } from 'ahooks';
import DownloadApp from '@/pages/download-app';

const AwakenApp: React.FC = () => {
  const { queryParams } = useParams();
  const { path, ...rest } = queryParams;
  const [showDownload, setShowDownload] = useState(false);
  // const navigate = useNavigate();
  useTitle('爱学AI学');

  useMount(() => {
    location.href = `yawwaixue://common/open_router?path=${path}&args=${encodeURIComponent(JSON.stringify(rest))}`;
    setTimeout(() => {
      // navigate('/download-app', { replace: true });
      setShowDownload(true);
    }, 3000);
  });

  return (
    <div className="flex flex-col items-center justify-center h-100vh">
      {showDownload ? (
        <DownloadApp />
      ) : (
        <div className="flex items-center justify-center">
          <span className="text-12px text-gray-500">跳转中</span>
          <DotLoading />
        </div>
      )}
    </div>
  );
};
export default AwakenApp;
